import XLSX from 'xlsx'; // excel to js https://github.com/SheetJS/sheetjs


//
const excel_column_sorted_keys_a_to_z = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  /*
  "aa",
  "ab",
  "ac",
  */
];


//
export const _excel_utils_excel_column_sorted_keys_make = (size, UPPERCASE, single_character_only = false) => {
  let counter = 0;
  let _max = 500;
  if (size > 0) {
    _max = size;
  }
  let _excel_column_keys = [];
  // single character columns
  // let _excel_column_keys = [...excel_column_sorted_keys_a_to_z];
  excel_column_sorted_keys_a_to_z.forEach((char) => {
    counter++;
    if (counter < _max || counter === _max) {
      if (UPPERCASE === true) { // UPPERCASE
        _excel_column_keys.push(char.toUpperCase()); // single character UPPERCASE
      } else { // .toLowerCase
        _excel_column_keys.push(char); // 
      }
    }
  });
  // two character columns
  if (single_character_only === true) {
    // skip
  } else {
    excel_column_sorted_keys_a_to_z.forEach((char) => {
      excel_column_sorted_keys_a_to_z.forEach((char2) => {
        counter++;
        if (counter < _max || counter === _max) {
          if (UPPERCASE === true) { // UPPERCASE
            _excel_column_keys.push(char.toUpperCase() + char2.toUpperCase()); // two characters UPPERCASE
          } else { // .toLowerCase
            _excel_column_keys.push(char + char2); // 
          }
        }
      });
    });
  }
  return _excel_column_keys;
};


//
export const _excel_utils_export_table_with_keyval_header = (excelExportPack) => {
  //
  const {
    generalDefinition,
    keyval_header_data,
    tableCellsDefinition,
    table_data,
    exportedFilename,
  } = excelExportPack;
  console.log('_excel_utils_export_table_with_keyval_header UNIVERSAL', excelExportPack);
  const {
    HOW_MANY_EMPTY_ROWS_AFTER_KEYVAL_HEADER,
    TABLE_HEADER_ROW_HEIGHT,
  } = generalDefinition;
  //
  const TABLE_HEADER_ROW_INDEX = keyval_header_data.length + HOW_MANY_EMPTY_ROWS_AFTER_KEYVAL_HEADER;
  const TABLE_NUMBER_OF_COLUMNS = tableCellsDefinition.length;
  //
  //
  const _prepare_excel_cell = (cell) => {
    if (typeof cell.v === 'number') {
      cell.t = 'n';
    } else if (typeof cell.v === 'boolean') {
      cell.t = 'b';
      /*
    } else if (cell.v instanceof Date) {
      cell.t = 'n';
      cell.z = XLSX.SSF._table[14];
      cell.v = dateNum(cell.v);
      */
    } else {
      cell.t = 's';
      if (typeof cell.v === 'undefined') {
        cell.v = '';
      }
      if (cell.v === null) {
        cell.v = '';
      }
    }
    return cell;
  };
  //
  const createSheet = (data, opts) => {
    console.log('createSheet(data, opts)');
    console.log(data, opts);
    const ws = {};
    // var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } }; 
    // Cell range objects are stored as {s:S, e:E} where S is the first cell and E is the last cell in the range.
    // let range = { s: { c: 0, r: 0 }, e: { c: 13, r: 8 } }; // TODO
    const LAST_RANGE_COLUMN_INDEX = TABLE_NUMBER_OF_COLUMNS + 1;
    const LAST_RANGE_ROW_INDEX = TABLE_HEADER_ROW_INDEX;
    let range = { s: { c: 0, r: 0 }, e: { c: LAST_RANGE_COLUMN_INDEX, r: LAST_RANGE_ROW_INDEX } }; //
    //
    //
    const COL_WIDTH = 50;

    /* Excel column "C" -> SheetJS column index 2 == XLSX.utils.decode_col("C") */
    var COL_INDEX = 2;

    // ----- STEP) set column width
    /* create !cols array if it does not exist */
    if (!ws["!cols"]) ws["!cols"] = [];
    /* set column width */
    /* create column metadata object if it does not exist */
    // // if(!ws["!cols"][COL_INDEX]) ws["!cols"][COL_INDEX] = {wch: 8};
    // ws["!cols"][COL_INDEX].wpx = COL_WIDTH;
    // if (!ws["!cols"][0]) ws["!cols"][0] = { wch: 6.5, /* wpx: 57 */ };
    /*
    if (!ws["!cols"][1]) ws["!cols"][1] = { wch: 12 }; // Nivo
    if (!ws["!cols"][2]) ws["!cols"][2] = { wch: 5.5 }; // Kat
    */
    // if (!ws["!cols"][3]) ws["!cols"][3] = { wch: 7, /* wpx: 107 */ }; // Grupa
    /*
    if (!ws["!cols"][4]) ws["!cols"][4] = { wch: 12.75 }; // Nadredjeni
    if (!ws["!cols"][5]) ws["!cols"][5] = { wch: 18 }; // Radni nalog ista sirina kao Ident
    if (!ws["!cols"][6]) ws["!cols"][6] = { wch: 12.75 }; // InfoID
    if (!ws["!cols"][7]) ws["!cols"][7] = { wch: 18 }; // Ident
    if (!ws["!cols"][8]) ws["!cols"][8] = { wch: 60 }; // Naziv
    if (!ws["!cols"][9]) ws["!cols"][9] = { wch: 11 }; // Kolicina_za_nalog
    // // if (!ws["!cols"][9]) ws["!cols"][9] = { wch: 11 }; // Kolicina
    if (!ws["!cols"][10]) ws["!cols"][10] = { wch: 5.5 }; // JM
    if (!ws["!cols"][11]) ws["!cols"][11] = { wch: 25 }; // RC
    */
    tableCellsDefinition.forEach((col_def, index) => {
      if (!ws["!cols"][index]) ws["!cols"][index] = { wch: col_def.wch }; //
    });

    // ----- STEP) ispis table_row values
    // const TABLE_HEADER_ROW_INDEX = 8;
    // const TABLE_HEADER_ROW_INDEX = 9; // NOVO
    for (let _R = 0; _R < data.length; _R++) { // each row
      // _R je row index - index reda sastavnice
      const body_row_no = _R + 1; // brojac ispisanih "body" redova (ispod header reda) pocinje od 1.
      const R = _R + TABLE_HEADER_ROW_INDEX + 1; // zapocinje redove sastavnice posle header reda // 0-index cell adsress
      const row_obj = data[_R];
      // for (var C = 0; C != data[R].length; ++C) { // each column
      // for (var i = 0; i < 12; i++) { // each column
      for (var colindex = 0; colindex < TABLE_NUMBER_OF_COLUMNS; colindex++) { // each column
        //
        let C = colindex; // 0-index cell adsress
        let key;
        // let val;
        let val = null;
        /*
        if (i === 0) { // first column polje Poz.
          val = body_row_no; // ispisuje broj reda sastavnice
        }
        if (i === 1) {
          key = 'Nivo';
          val = data[_R][key];
        }
        */
        if (tableCellsDefinition[colindex]) {
          const col_def = tableCellsDefinition[colindex];
          if (col_def.key) {
            key = col_def.key;
            val = data[_R][key]; // data[_R] is data_row, object from array of objects
          }
          if (typeof col_def.cb === 'function') {
            val = col_def.cb(row_obj, _R); // _R is table data row index
          }
        }
        //
        //
        // if (range.s.r > R) range.s.r = R;
        // if (range.s.c > C) range.s.c = C;
        if (range.e.r < R) range.e.r = R;
        if (range.e.c < C) range.e.c = C;
        // var cell = { v: data[R][C] };
        var cell = { v: val };
        if (cell.v === null) continue;
        const cell_ref = XLSX.utils.encode_cell({ c: C, r: R }); // Convert 0-index cell adsress to A1 form
        // console.log(cell_ref); // A9 B9 C9...
        //
        // ws[cell_ref] = cell;
        ws[cell_ref] = _prepare_excel_cell(cell);
        // console.log(cell);
      }
    }
    // console.log(range.s.c);
    if (range.s.c < 10000000) {
      ws['!ref'] = XLSX.utils.encode_range(range); // Converts 0-indexed range to A1 form
    }
    /*
    https://stackoverflow.com/questions/37680884/how-to-add-filter-in-excel-generated-using-js-xlsx-plugin
    You can add the following line just before the return statement in your createSheet function.
 
    ws['!autofilter']={ref:"A1:E1"};
    */
    // ws['!autofilter'] = { ref: "A8:K8" };
    //

    // ----- STEP) kreiranje table_header_row reda
    // worksheet[itm].s = { fill: { fgColor: { rgb: "7A7A7A" } }, font: { color: { rgb: "FFFFFF" } } }
    const _style = {
      fill: { fgColor: { rgb: "DCEAF8" }, patternType: "solid", },
      // fill: { fgColor: { rgb: "296FAD" }, patternType: "solid", },
      // font: { color: { rgb: 'FFFFFF' } },
      font: { color: { rgb: '296FAD' }, bold: true },
      alignment: { vertical: 'left', horizontal: 'center' }
    };
    // ws[XLSX.utils.encode_cell({ c: 0, r: TABLE_HEADER_ROW_INDEX })] = { t: 's', v: 'Poz.', s: { ..._style } };
    // // ws[XLSX.utils.encode_cell({ c: 9, r: TABLE_HEADER_ROW_INDEX })] = { t: 's', v: 'Kolic.' };
    // ws[XLSX.utils.encode_cell({ c: 10, r: TABLE_HEADER_ROW_INDEX })] = { t: 's', v: 'JM' };
    // ws[XLSX.utils.encode_cell({ c: 11, r: TABLE_HEADER_ROW_INDEX })] = { t: 's', v: 'Radni centar' };
    // ws[XLSX.utils.encode_cell({ c: 10, r: 8 })] = { t: 's', v: 'JM', s: { ..._style } };
    tableCellsDefinition.forEach((col_def, index) => {
      // ws[XLSX.utils.encode_cell({ c: index, r: TABLE_HEADER_ROW_INDEX })] = { t: 's', v: col_def.title };
      ws[XLSX.utils.encode_cell({ c: index, r: TABLE_HEADER_ROW_INDEX })] = { t: 's', v: col_def.title, s: { ..._style } };
    });


    // ----- STEP) set autofilter za table_header_row
    // ws['!autofilter'] = { ref: "A9:L9" }; // TODO
    // ws['!autofilter'] = { ref: "A" + (TABLE_HEADER_ROW_INDEX + 1) + ":L" + (TABLE_HEADER_ROW_INDEX + 1) }; // TODO
    const _excel_sorted_keys = _excel_utils_excel_column_sorted_keys_make(1000, true);
    // const _LAST_COLUMN_EXCEL_KEY = _excel_sorted_keys[TABLE_NUMBER_OF_COLUMNS - 1].toUpperCase();
    let _LAST_COLUMN_EXCEL_KEY = "A";
    if (TABLE_NUMBER_OF_COLUMNS > 0) {
      _LAST_COLUMN_EXCEL_KEY = _excel_sorted_keys[TABLE_NUMBER_OF_COLUMNS - 1];
    }
    ws['!autofilter'] = { ref: "A" + (TABLE_HEADER_ROW_INDEX + 1) + ":" + _LAST_COLUMN_EXCEL_KEY + "" + (TABLE_HEADER_ROW_INDEX + 1) }; // TODO
    //
    // ws[XLSX.utils.encode_cell({ c: 10, r: TABLE_HEADER_ROW_INDEX })].v = 'JM'; // ???
    /*
    ws[XLSX.utils.encode_cell({ c: 11, r: 6 })] = { t: 's', v: 'TEST' };
    ws[XLSX.utils.encode_cell({ c: 12, r: 7 })] = { t: 's', v: 'TEST', s: { ..._style } };
    ws[XLSX.utils.encode_cell({ c: 11, r: 7 })] = { t: 's', v: 'TEST' };
    ws[XLSX.utils.encode_cell({ c: 12, r: 7 })] = { t: 's', v: 'TEST', s: { ..._style } };
    */

    /*
    ws[XLSX.utils.encode_cell({ c: 0, r: 0 })] = { t: 's', v: 'TEST' };
    ws[XLSX.utils.encode_cell({ c: 2, r: 0 })] = { t: 's', v: 'TEST 2' };
    ws[XLSX.utils.encode_cell({ c: 2, r: 0 })] = {
      t: 's',
      v: 'TEST2',
      // c: 'TEST 2', // c	 cell comments (More Info)
      r: '<t>TEST2</t>', // r rich text encoding (if applicable)
      h: '<b>TEST2</b>', // h	 HTML rendering of the rich text (if applicable)
      w: 'TEST2', // w	formatted text (if applicable)
    };
    */

    // ----- STEP) ispis key kolone za keyval_header
    /*
    ws[XLSX.utils.encode_cell({ c: 0, r: 0 })] = { t: 's', v: 'Kreirao:' };
    ws[XLSX.utils.encode_cell({ c: 0, r: 1 })] = { t: 's', v: 'Datum ispisa:' };
    ws[XLSX.utils.encode_cell({ c: 0, r: 2 })] = { t: 's', v: 'Nosioc troska:' };
    ws[XLSX.utils.encode_cell({ c: 0, r: 3 })] = { t: 's', v: 'Naziv projekta:' };
    ws[XLSX.utils.encode_cell({ c: 0, r: 4 })] = { t: 's', v: 'Narudzbina:' };
    ws[XLSX.utils.encode_cell({ c: 0, r: 5 })] = { t: 's', v: 'Proizvod:' };
    ws[XLSX.utils.encode_cell({ c: 0, r: 6 })] = { t: 's', v: 'Naziv sistema:' };
    ws[XLSX.utils.encode_cell({ c: 0, r: 7 })] = { t: 's', v: 'Tip komore:' };
    */
    keyval_header_data.forEach((keyval, index) => {
      // c:0 znaci da se ispisuje u prvu kolumnu
      ws[XLSX.utils.encode_cell({ c: 0, r: index })] = { t: 's', v: keyval.key };
    });

    // ----- STEP) ispis val kolone za keyval_header
    /*
    const datum_ispisa = current_time_utc.slice(0, 10);
    ws[XLSX.utils.encode_cell({ c: 2, r: 1 })] = _prepare_excel_cell({ t: 's', v: datum_ispisa });
    */
    keyval_header_data.forEach((keyval, index) => {
      // c:2 znaci da se ispisuje u trecu kolumnu
      ws[XLSX.utils.encode_cell({ c: 2, r: index })] = _prepare_excel_cell({ t: 's', v: keyval.val });
    });

    // ws[XLSX.utils.encode_cell({ c: 1, r: 0 })].c = 'TEST 2';

    // ----- STEP) set table_header_row height
    // const TABLE_HEADER_ROW_HEIGHT = 27.75;
    // const ROW_INDEX = 8;
    /* create !rows array if it does not exist */
    if (!ws["!rows"]) ws["!rows"] = [];
    /* create row metadata object if it does not exist */
    // if (!ws["!rows"][0]) ws["!rows"][0] = { hpt: 77, /* hpx: TABLE_HEADER_ROW_HEIGHT */ };
    if (!ws["!rows"][TABLE_HEADER_ROW_INDEX]) ws["!rows"][TABLE_HEADER_ROW_INDEX] = { hpt: TABLE_HEADER_ROW_HEIGHT, /* hpx: TABLE_HEADER_ROW_HEIGHT */ };
    /* set row height */
    // ws["!rows"][TABLE_HEADER_ROW_INDEX].hpx = TABLE_HEADER_ROW_HEIGHT;
    ws["!rows"][TABLE_HEADER_ROW_INDEX].hpt = TABLE_HEADER_ROW_HEIGHT;
    // ws["!rows"][TABLE_HEADER_ROW_INDEX].hpx = 37;
    // ws["!rows"][0].hpx = 107;
    //
    return ws;
  };
  //
  //
  // const ws_name = "SheetJS";
  const ws_name = "Sheet1";
  const ws = createSheet(table_data); /* Create worksheet */

  // https://docs.sheetjs.com/docs/solutions/processing
  /* Create workbook */
  const wb = XLSX.utils.book_new(); // excel workbook
  // const workbook = wb;

  /* Add the worksheet to the workbook */
  XLSX.utils.book_append_sheet(wb, ws, ws_name);
  console.log('workbook ready to export', wb);

  /* Write to file */
  // XLSX.writeFile(wb, "SheetJS.xlsx");
  // const exportedFilename = fileTitle + '.xlsx' || 'export.xlsx';
  //
  // XLSX.writeFile(wb, exportedFilename);
  XLSX.writeFile(wb, exportedFilename, {
    cellStyles: true // The cellStyles option must be set to true to export column properties:
  }); // https://docs.sheetjs.com/docs/csf/features/colprops/

  ///////
  /*
  var blob = new Blob([string], { type: 'application/json;charset=utf-8;' });
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, exportedFilename);
  } else {
    var link = document.createElement("a");
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  */
};

